var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import ReactEcharts from 'echarts-for-react';
import * as _ from "lodash";
import * as React from 'react';
import { setOrDef } from '../Helpers';
import elementResizeDetectorMaker from 'element-resize-detector';
import { ImgStatisticsConfig } from "./ImgStatisticsConfig";
var erdUltraFast = elementResizeDetectorMaker({
    strategy: "scroll" //<- For ultra performance.
});
var DiagramBase = /** @class */ (function (_super) {
    __extends(DiagramBase, _super);
    function DiagramBase(props) {
        var _this = _super.call(this, props) || this;
        _this.setRef = function (ref) {
            _this.containingDiv = ref;
            if (ref)
                erdUltraFast.listenTo(ref, function (ele) {
                    var d = _this.props.diagram;
                    var wSub = setOrDef(d.padding, function (x) { return x.left; }, 20) + setOrDef(d.padding, function (x) { return x.right; }, 20);
                    var hSub = setOrDef(d.padding, function (x) { return x.top; }, 40) + setOrDef(d.padding, function (x) { return x.bottom; }, 20);
                    _this.onResize(ele.offsetWidth - wSub, ele.offsetHeight - hSub);
                });
        };
        _this.onResize = function (width, height) {
        };
        _this.redraw = function () {
            _this.forceRedraw = true;
        };
        _this.getClickPath = function (data) {
            var d = _this.props.diagram;
            var toRet = {};
            toRet[d.groupBy[0]] = data.name;
            toRet[d.groupBy[1]] = data.seriesName;
            return toRet;
        };
        _this.findDataElement = function (path) {
            //        console.log(this.state.data);
            throw new Error("You must implement findDataElement!");
        };
        _this.getOption = function () {
            throw new Error("You must implement getOption!");
        };
        _this.calcData = function (nextProps) {
            throw new Error("You must implement calcData!");
        };
        _this.setupMinAndMax = function () {
        };
        _this.saveImage = function () {
            _this.instance.getDataURL();
        };
        _this.setInstance = function (instance) {
            _this.instance = instance;
        };
        _this.getLabelFormatter = function (label) {
            if (label.formatterType) {
                var formatterType_1 = ImgStatisticsConfig.getInstance().getFormatter(label.formatterType.type);
                if (formatterType_1) {
                    var payload_1 = label.formatterType.payload;
                    return function (params) {
                        return formatterType_1(params, payload_1);
                    };
                }
                else
                    return label.formatter;
            }
            else
                return label.formatter;
        };
        _this.state = {};
        _this.forceRedraw = false;
        _this.needRecalc = _this.needRecalc.bind(_this);
        _this.onClick = _this.onClick.bind(_this);
        return _this;
    }
    DiagramBase.prototype.componentWillMount = function () {
        this.calcData(this.props);
    };
    DiagramBase.prototype.componentWillReceiveProps = function (nextProps) {
        if (this.needRecalc(nextProps))
            this.calcData(nextProps);
    };
    DiagramBase.prototype.render = function () {
        var _this = this;
        var d = this.props.diagram;
        var option = {};
        var opt = this.getOption();
        _.forEach(opt, function (o, i) {
            if (opt[i])
                option[i] = o;
        });
        if (option && opt) {
            this.setupMinAndMax();
            _.forEach(d.nodeManipulation, function (m) {
                var val = _this.findDataElement(m.path);
                if (val) {
                    _.forEach(val, function (vv) { return _.forEach(m.data, function (v, i) { return vv[i] = v; }); });
                }
            });
            var setOpt = __assign(__assign({}, option), { legend: d.type !== "Sunburst" && d.type !== "Tree" ? {
                    show: d.legend && d.legend.show,
                    orient: setOrDef(d.legend, function (x) { return x.direction; }, "horizontal"),
                    align: setOrDef(d.legend, function (x) { return x.itemAlign; }, "auto"),
                    left: setOrDef(d.legend, function (x) { return x.horizontalAlignment; }, "center"),
                    top: setOrDef(d.legend, function (x) { return x.verticalAlignment; }, "middle"),
                    padding: d.legend && d.legend.padding ? [
                        setOrDef(d.legend.padding, function (x) { return x.top; }, 0),
                        setOrDef(d.legend.padding, function (x) { return x.right; }, 0),
                        setOrDef(d.legend.padding, function (x) { return x.bottom; }, 0),
                        setOrDef(d.legend.padding, function (x) { return x.left; }, 0),
                    ] : [0, 0, 0, 0]
                } : undefined });
            if (this.instance) {
                if (this.forceRedraw) {
                    this.instance.setOption({}, true);
                    this.forceRedraw = false;
                }
                this.instance.setOption(setOpt, true);
            }
            //            console.log("setOpt = > ", this.id, " -- ", setOpt);
            return (React.createElement("div", { style: { width: "100%", height: "100%" }, ref: this.setRef },
                React.createElement(ReactEcharts, { option: setOpt, style: {
                        height: "100%",
                        paddingTop: setOrDef(d.padding, function (x) { return x.top; }, 40),
                        paddingBottom: setOrDef(d.padding, function (x) { return x.bottom; }, 20),
                        paddingLeft: setOrDef(d.padding, function (x) { return x.left; }, 20),
                        paddingRight: setOrDef(d.padding, function (x) { return x.right; }, 20),
                    }, onChartReady: this.setInstance, 
                    // opts={{ renderer: 'svg' }}
                    onEvents: {
                        click: this.onClick
                    } })));
        }
        return React.createElement("div", null);
    };
    DiagramBase.prototype.needRecalc = function (nextProps) {
        var d = this.props.diagram;
        var recalc = false;
        recalc = recalc || d.enableSpecificStyling !== nextProps.diagram.enableSpecificStyling;
        //        recalc = recalc || d.aggregationGrouping !== nextProps.diagram.aggregationGrouping;
        recalc = recalc || !_.isEqual(d.groupBy, nextProps.diagram.groupBy);
        //        recalc = recalc || !_.isEqual(d.filter, nextProps.diagram.filter);
        //        recalc = recalc || !_.isEqual(d.requestFilter, nextProps.diagram.requestFilter);
        recalc = recalc || !_.isEqual(d.aggregators, nextProps.diagram.aggregators);
        recalc = recalc || this.props.lng !== nextProps.lng;
        recalc = recalc || d.url !== nextProps.diagram.url;
        return recalc;
    };
    DiagramBase.prototype.onClick = function (data) {
        var d = this.props.diagram;
        if (this.props.onClick)
            this.props.onClick(d, data);
        if (!d.enableSpecificStyling)
            return;
        //        console.log(data);
        /*const path = this.getClickPath(data);
        //        console.log(path);
                const state = store.getState();
                // get path to element
        
                if (state.getOneStyle) {
                    // get style using pipette
                    //
                    const idx = _.findIndex(d.nodeManipulation, n => _.isEqual(n.path, path));
                    //            console.log(idx);
                    let curStyle: SunburstPartStyle | undefined;
                    if (idx >= 0 && d.nodeManipulation) {
                        const ele = d.nodeManipulation[idx];
                        curStyle = {
                            smallRadius: getStylePercentage(ele.data.r0),
                            largeRadius: getStylePercentage(ele.data.r),
                            color: ele.data.itemStyle.color,
                            labelColor: ele.data.label.color,
                            labelOrientation: ele.data.label.rotate,
                            labelPosition: ele.data.label.position,
                            labelDistance: ele.data.label.distance
                        };
        
                    }
                    if (!curStyle && d.sunburstRingStyles)
                        curStyle = _.cloneDeep(d.sunburstRingStyles[Object.keys(path).length - 1]);
                    store.dispatch(ActionCreators.SetDiagramCurStyle(curStyle));
                    store.dispatch(ActionCreators.GotOneStyle());
                }
                else if (state.getRingRadius) {
                    // get style using pipette
                    //
                    const idx = _.findIndex(d.nodeManipulation, n => _.isEqual(n.path, path));
                    //            console.log(idx);
                    let curStyle: SunburstPartStyle | undefined = state.curStyle;
        
                    if (!curStyle && d.sunburstRingStyles)
                        curStyle = _.cloneDeep(d.sunburstRingStyles[Object.keys(path).length - 1]);
                    if (curStyle && d.sunburstRingStyles) {
                        const rs = d.sunburstRingStyles;
                        curStyle.smallRadius = rs[Object.keys(path).length - 1].smallRadius;
                    }
                    if (curStyle && d.sunburstRingStyles) {
                        const rs = d.sunburstRingStyles;
                        curStyle.largeRadius = rs[Object.keys(path).length - 1].largeRadius;
                    }
        
                    store.dispatch(ActionCreators.SetDiagramCurStyle(curStyle));
                    store.dispatch(ActionCreators.GotRingRadius());
                }
                else {
                    // apply style to selected node
                    const cs = state.curStyle;
                    const cpy: Diagram = _.cloneDeep(d);
        
                    if (!cpy.nodeManipulation)
                        cpy.nodeManipulation = [];
                    const idx = _.findIndex(cpy.nodeManipulation, n => _.isEqual(n.path, path));
                    //            console.log(idx);
                    //            console.log(cs);
                    if (cs) {
                        //                console.log("assign style");
                        const newEle: NodeManipulation = {
                            path,
                            data: {
                                r0: cs.smallRadius ? cs.smallRadius + "%" : undefined,
                                r: cs.largeRadius ? cs.largeRadius + "%" : undefined,
                                itemStyle: {
                                    color: cs.color
                                },
                                label: {
                                    color: cs.labelColor,
                                    rotate: cs.labelOrientation,
                                    position: cs.labelPosition,
                                    distance: cs.labelDistance,
                                }
                            }
                        };
                        if (idx < 0)
                            cpy.nodeManipulation.push(newEle);
                        else
                            cpy.nodeManipulation[idx] = newEle;
                        //                console.log(cpy);
                        //                console.log(this.props);
                    }
                    else {
                        //                console.log("remove style");
                        if (idx >= 0) {
                            const val = this.findDataElement(cpy.nodeManipulation[idx].path);
                            //                    console.log(val);
                            if (val) {
                                _.forEach(val, vv => {
                                    vv.r0 = undefined;
                                    vv.r = undefined;
                                    vv.itemStyle = undefined;
                                    vv.label = undefined;
                                });
                            }
                            cpy.nodeManipulation.splice(idx, 1);
                        }
                    }
                    const call = this.props.onDataChanged;
                    //            console.log(call);
                    if (call) {
                        //                console.log(cpy);
                        call(cpy);
                    }
                }
                */
    };
    return DiagramBase;
}(React.Component));
export { DiagramBase };
//# sourceMappingURL=DiagramBase.js.map